import { render, staticRenderFns } from "./PostLike.vue?vue&type=template&id=6a3ed1bc&scoped=true&"
import script from "./PostLike.vue?vue&type=script&lang=js&"
export * from "./PostLike.vue?vue&type=script&lang=js&"
import style0 from "./PostLike.vue?vue&type=style&index=0&id=6a3ed1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ed1bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
